const CREATOR_HUB_NOTIFICATION_CHANNEL = 8;

export default CREATOR_HUB_NOTIFICATION_CHANNEL;
